import { environment } from 'src/environments/environment';

export const ChatbotConfig = {
	API_BASE_URL: environment.CHATBOT_API_BASE_URL,
	WS_URL: environment.CHATBOT_WS_URL,
	API_KEY: environment.CHATBOT_API_KEY,
	ENDPOINTS: {
		UPLOAD: '/upload/file',
		MESSAGE: '/message'
	}
};
